@if (createSparkCampaignService.currentSparkCampaign() !== undefined) {
<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div class="flex-0 flex flex-row items-center justify-between w-full">
        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToBriefs()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">Create Ad-Group
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">{{
                    createSparkCampaignService.currentSparkCampaign()?.campaignName ?? 'Loading...' }}</p>
            </div>
        </div>
    </div>

    <div class="h-full flex-1 flex-col items-center justify-start w-full overflow-y-auto scrollbar-transparent gap-y-8">


        <!-- Ad Group Name -->
         <cad-group-name></cad-group-name>
        <!-- Ad Group Name - END -->

        <!-- Placements -->
         <cad-group-placements></cad-group-placements>
        <!-- Placements - END -->

        <!-- Targeting -->
        <cad-group-targeting></cad-group-targeting>
        <!-- Targeting - END -->

        <!-- Brand Safety & Suitability -->
         <!-- Coming Soon.... -->
         <!-- <cad-group-brand-safety-suitability></cad-group-brand-safety-suitability> -->
        <!-- Brand Safety & Suitability - END -->

        <!-- Budget & Schedule -->
         <cad-group-budget-schedule></cad-group-budget-schedule>
        <!-- Budget & Schedule - END -->

        <!-- Bidding & Optimization -->
         <cad-group-bidding-optimization></cad-group-bidding-optimization>
        <!-- Bidding & Optimization - END -->



    </div>

    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-t border-zinc-200 dark:border-zinc-800 pt-2">
        <button (click)="backToBriefs()" type="button" class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
            Exit
        </button>


        <button (click)="checkAdGroup()" type="button" class="primary-button inline-flex flex-row items-center gap-x-2">
            Continue
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </button>
    </div>
</div>
} @else {
<div class="h-full flex flex-col justify-center items-center overflow-hidden space-y-4">
    <p class="text-sm text-gray-500 dark:text-gray-400">Loading...</p>
</div>
}